import React, { useState } from "react";
import { useSelector } from "react-redux";
import { getExpertAnalytics } from "../../../../API/api";
import { Spin } from "antd";
import StaticTableAnt from "../../../AntDesignTable/StaticTableAnt";
import CountUp from "react-countup";
import TitleValue from "../seeker/TitleValue";
import { Rate } from 'antd';
import { Progress } from "antd";
import { ReactComponent as ViewIcon } from "../../../../Icons/totalView.svg";
{/* <ViewIcon /> */}

const containerStyle = {
  width: "100%",
  margin: "auto",
  marginTop: "1%",
  marginBottom: "1%",
  border: "1px solid #E0E2E6",
  background: "#FFFFFF",
  borderRadius: "12px",
  boxShadow: "0px 4px 16px 0px #1018280F",
  padding: "28px",

};
const columnsData = [
  // {
  //   title: TitleValue("Geo"),
  //   dataIndex: "Geo",
  //   sorter: (a, b) => a?.Geo?.localeCompare(b?.Geo),
  //   align: "left",
  //   width: 160,
  //   render: (_, raw) => (
  //     <>
  //       <span style={{ fontSize: "13px", fontWeight: "300" }}>{raw.Geo}</span>
  //     </>
  //   ),
  // },
  {
    title: TitleValue("Expert Name"),
    dataIndex: "Expert",
    sorter: (a, b) => a.Expert.localeCompare(b.Expert),
    align: "left",
    width: 250,
    render: (_, raw) => (
      <>
        <span style={{  fontSize: "13px",
              color: "#2A364A",
              fontWeight: "500", }}>
          {/* <CountUp end={raw.Expert} /> */}
          {raw.Expert}
        </span>
      </>
    ),
  },
  {
    title: TitleValue("Answered"),
    dataIndex: "Answered",
    sorter: (a, b) => a.Answered - b.Answered,
    align: "center",
    width: 150,
    render: (_, raw) => (
      <>
        <span
          style={{
            fontSize: "13px",
              color: "#2A364A",
              fontWeight: "500",
            display: "flex",
            width: "50%",
            justifyContent: "flex-end",
            textAlign: "right",
          }}
        >
          <CountUp end={raw.Answered} />
          {/* {raw.Answered} */}
        </span>
      </>
    ),
  },

  {
    title: TitleValue("Rating CNT"),
    dataIndex: "RatingCNT",
    sorter: (a, b) => a.RatingCNT - b.RatingCNT,
    align: "center",
    width: 150,
    render: (_, raw) => (
      <>
        <span
          style={{
            fontSize: "13px",
            color: "#2A364A",
            fontWeight: "500",
            display: "flex",
            width: "50%",
            justifyContent: "flex-end",
            textAlign: "right",
          }}
        >
          <CountUp end={raw.RatingCNT} />
          {/* {raw.RatingCNT} */}
        </span>
      </>
    ),
  },
  {
    title: TitleValue("Avg Of Rating"),
    dataIndex: "AvgOfRating",
    sorter: (a, b) => a.AvgOfRating - b.AvgOfRating,
    align: "center",
    width: 150,
   render: (_, raw) => {
        const rating = raw.AvgOfRating; // This should already be out of 5
        return (
          <div style={{
            fontSize: "13px",
            color: "#2A364A",
            fontWeight: "500",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            justifyContent: "center"
          }}>
            <Rate allowHalf disabled value={rating} style={{ fontSize: 14 }} />
          </div>
        );
      },
  },
  {
    title: TitleValue("Views"),
    dataIndex: "Views",
    sorter: (a, b) => a.Views - b.Views,
    align: "center",
    width: 150,
    render: (_, raw) => (
      <>
       
        <span
            style={{
              fontSize: "13px",
              color: "#2A364A",
              fontWeight: "500",
              display: "flex",
              width: "100%",
              justifyContent: "center",
              textAlign: "center",
              gap: "5px",
              // marginLeft: "10px"
            }}
          >
            <CountUp end={raw.Views} />
            <ViewIcon />
            {/* {raw.TrendingViews} */}
          </span>
      </>
    ),
  },
  {
    title: TitleValue("Rated"),
    dataIndex: "Rated",
    sorter: (a, b) => a.Rated - b.Rated,
    align: "center",
    width: 150,
    render: (_, raw) => (
      <>
       
        <div style={{
          fontSize: "13px",
          color: "#2A364A",
          fontWeight: "500",
          display: "flex", justifyContent: "center", alignItems: "center"
        }}>
          <Progress
            type="circle"
            percent={raw.Rated}
            width={30}
            strokeColor={
              raw.Rated > 70 ? " #B85CFF" :
                raw.Rated > 40 ? "#B85CFF" :
                  "#2A364A"
            }
            format={(percent) => (
              <span style={{ fontSize: "10px", padding: "2px", color: "#2A364A", }}>{percent}%</span>
            )}
          />
        </div>
      </>
    ),
  },
];

export default function ExpertAnswerStatistics() {
  // const [userType, setUserType] = useState("");
   const [sortInfo, setSortInfo] = useState({});
    
  const [expertAnalytics, setExpertAnalytics] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const { geoLevelId, geoLevelValue, domainId, length, check } = useSelector(
    (state) => {
      return {
        geoLevelId: state.cmRoot.selecetdRoutingValue,
        geoLevelValue: state.cmRoot?.selectedGeoLevel?.name,
        domainId: state.cmRoot?.selectedDomainIds,
        length: state.cmRoot?.selectedDomainsObj?.length,
        check: state.cmRoot.selecetdRoutingValue,
      };
    }
  );

  React.useEffect(() => {
    if (check !== "") {
      setLoading(true);
      getExpertAnalytics(geoLevelId, geoLevelValue, domainId, setCount).then(
        (res) => {
          if (res===undefined) return;
          setLoading(false);
          setExpertAnalytics(res);
        }
      );
    }
    setCurrentPage(1);
  }, [domainId, geoLevelId, geoLevelValue, length, check]);

  return (
    <>
      <div
      // className={styles.seekerOutline}
      // style={{ border: "none" }}
      // style={containerStyle}
      >
        <Spin
          spinning={loading}
          style={{
            // marginTop: "30px",
            width: "100%",
            padding: "30px",
          }}
        >
          <div
            style={{
              width: "100%",
              paddingRight: "15px",
              // paddingTop: "15px",
              paddingBottom: "30px",
            }}
          >
            <StaticTableAnt
              columns={columnsData}
              data={expertAnalytics}
              searchValue={searchValue}
              setSearchValue={setSearchValue}
              count={count}
              Header="Expert Answers Statistics"
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              searchBoolean={true}
              sortInfo={sortInfo}
              setSortInfo={setSortInfo}
            />
          </div>
        </Spin>
      </div>
    </>
  );
}
